{
  "title": "Sign-in and security",
  "required": "Add a passkey or an authenticator app to continue. Everyone needs a second factor, guests included.",
  "passkeys": "Passkeys",
  "passkeysLead": "Sign in without a password using your device or a security key.",
  "addPasskey": "Add a passkey",
  "passkeyName": "Name for this passkey",
  "passkeyNameDefault": "My device",
  "noPasskeys": "No passkeys yet.",
  "lastUsed": "Last used {{date}}",
  "neverUsed": "Never used",
  "synced": "Synced",
  "deviceBound": "This device only",
  "totp": "Authenticator app",
  "totpLead": "Codes from Google Authenticator, 1Password, Aegis or similar, with your password.",
  "totpEnabled": "Enabled",
  "totpSetup": "Set up",
  "totpScan": "Scan this code with your app, or enter the key by hand, then type the 6-digit code.",
  "totpKey": "Key",
  "totpConfirm": "Confirm",
  "totpDisable": "Turn off",
  "recoveryTitle": "Save your recovery codes",
  "recoveryLead": "Each code works once if you lose your authenticator app. They are shown only now.",
  "recoveryDone": "I saved them",
  "intro": "How you sign in to CloudServer. Use a passkey where you can; keep a second way in case you lose a device.",
  "removePasskeyTitle": "Remove the passkey “{{name}}”?",
  "removePasskeyEffect": "You can no longer sign in with it on that device.",
  "removePasskeyKeep": "The key may stay in your password manager or device; it simply stops working here.",
  "totpDisableTitle": "Turn off the authenticator app?",
  "totpDisableEffect": "Signing in with a password will no longer ask for a code.",
  "totpDisableCodes": "Your recovery codes stop working."
}
